const getPercentage = (total, value) => {
    return Math.ceil(value / total * 100);
}

export default getPercentage;